"use strict";

var LoggerInstance = require("js-logger").get("ProductVariantsHelper");

var Constants = require("../designer/Constants");
var ActionsHelper = require("../actions/ActionsHelper");

var ProductVariantsHelper = {
	initializeProductVariants: function($component, isDesignMode) {
		$component = $($component || "body");
		var $singleVariantComponent = $component.find("[data-component='productVariants.singleVariant']");

		$singleVariantComponent.off("click.productVariants");
		$singleVariantComponent.off("mousedown.productVariants");
		$singleVariantComponent.off("mouseup.productVariants");
		$singleVariantComponent.off("keyup.productVariants");

		$singleVariantComponent.on("click.productVariants", (event) => {
			this.variantClicked(event, isDesignMode);
		});

		$singleVariantComponent.on("mousedown.productVariants", (event) => {
			if (event && event.which === 2) {
				//Making it so middle click does not try to allow the user to scroll
				return false;
			}
		});

		$singleVariantComponent.on("mouseup.productVariants", (event) => {
			if (event && event.which === 2) {
				this.variantClicked(event, isDesignMode, /*openInNewTab*/ true);
			}
		});

		$singleVariantComponent.on("keyup.productVariants", (event) => {
			if (event && (event.which === Constants.KEYS.ENTER || event.which === Constants.KEYS.SPACE)) {
				this.variantClicked(event, isDesignMode);
			}
		});
	},

	variantClicked: function(event, isDesignMode, openInNewTab) {
		var $variant = $(event.target).closest(`[data-component="productVariants.singleVariant"]`);

		if ((event.ctrlKey || event.metaKey) && isDesignMode) {
			$variant.toggleClass("selected");
		}

		event = this._getEventOrReturn(event, "Variant Clicked", isDesignMode);
		if (!event) {
			return false;
		}

		var productUrl = $variant.attr("data-url");
		if (productUrl) {
			var url;
			if (productUrl.startsWith("/category")) {
				url = productUrl;
			} else {
				url = `/purchase/${productUrl}`;
			}
			if (openInNewTab) {
				window.open(url, '_blank');
			} else if (window.location.pathname !== url) {
				$variant.closest(`[data-component="productVariants"]`).find(`[data-component="productVariants.singleVariant"]`).removeClass("selected");
				$variant.addClass("selected");
				window.location = url;
			}
		}
	},

	_getEventOrReturn: function (event, isDesignModeMessage, isDesignMode) {
		return ActionsHelper.getEventOrReturn(event, isDesignMode, isDesignModeMessage, /*preventDefaultInDesignMode*/false);
	}
};

module.exports = ProductVariantsHelper;
